import React from 'react';
import { useSelector } from 'react-redux';

// React Bootstrap
import { Container, Col, Row, Button, Modal } from 'react-bootstrap';

// Packages
import PropTypes from 'prop-types';

const ConfirmDialog = (props) => {
	const { show, onHide, dialogFunction } = props;

	const { global_data } = useSelector(state => state.global);

	const imgStyles = {
		height: '30vh',
		display: 'block',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginBottom: '1rem'
	};
	
	return (
		<Modal
			show={show}
			onHide={onHide}
			backdrop='static'
			keyboard={false}
			size='lg'
			aria-labelledby='contained-modal-title-vcenter'
			centered
		>
			<Modal.Body>
				<img src={process.env.PUBLIC_URL + '/assets/question.png'} style={imgStyles} alt='Question' />

				<Container className='text-center mb-3'>
					<Modal.Title as='h2'>{global_data?.utils?.confirmDialogTitle}</Modal.Title>
					<p className='py-3'>{global_data?.utils?.confirmDialogText}</p>

					<Row>
						<Col className='d-flex justify-content-evenly'>
							<Button variant='outline-danger' onClick={onHide}>{global_data?.actionButtons?.cancel}</Button>
							<Button variant='primary' onClick={dialogFunction}>{global_data?.actionButtons?.confirm}</Button>
						</Col>
					</Row>
				</Container>
			</Modal.Body>
		</Modal>
	);
}

ConfirmDialog.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	dialogFunction: PropTypes.any
}

export default ConfirmDialog;
